import { type InputHTMLAttributes, forwardRef } from "react"
import { cn } from "../../lib/cn"

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, checked, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        className={cn(
          "h-4 w-4 rounded border border-slate-700 bg-slate-900 text-brand-500",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-0",
          "checked:bg-brand-600 checked:border-brand-600 checked:text-white",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...props}
      />
    )
  }
)

Checkbox.displayName = "Checkbox"

